import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";
import ScrollSection from "./ScrollSection";
import Bear from "./Bear";
import {colors} from "../assets/settings";
import InteractiveSection from "./InteractiveSection";
import Aperture from "./elements/Aperture";
import Parallax from "./elements/Parallax";

import CampusDesign from "./sections/CampusDesign";
import CampusPlanning from "./sections/CampusPlanning";
import LifeOnCampus from "./sections/LifeOnCampus";
import Academics from "./sections/Academics";
import GettingAround from "./sections/GettingAround";
import EnergyWaterClimate from "./sections/EnergyWaterClimate";
import CampusPriorities from "./sections/CampusPriorities";
import Conclusion from "./sections/Conclusion";

import ProgramGame from "./sections/ProgramGame";
import Welcome from "./sections/Welcome";
import AboutYou from "./elements/AboutYou";

function ScrollContent(props) {
    const {count, scrollProgress, store} = props;
    const testSections = [];
    for (let i = 0; i < count; i++) {
        testSections.push({v: i});
    }
    const getProgress = (key, clamp, normalize) => {
        return getProgressNorm(key, clamp, normalize, 1)
    };
    const getProgressNorm = (key, clamp, normMin, normMax) => {
        if (!normMax) normMax = 1;
        const section = store.sections.get(key);
        if (!section) return -1;
        if (clamp) {
            let val = section.scrollProgress;
            if (normMin) {
                val = (val - normMin) / (normMax - normMin);
            }
            return Math.max(0, Math.min(val, 1));
        }
        return section.scrollProgress;
    };
    const getState = (key) => {
        const section = store.sections.get(key);
        if (!section) return 'N/A';
        return section.scrollState;
    };
    const getScrollAmount = (sectionGroup) => {
        const activeKey = store.activeSection(sectionGroup);
        //console.log('getScrollAmount ' + sectionGroup + ': ' + activeKey);
        const num = parseInt(activeKey);
        if (`${num}` === activeKey) {
            return (num - 1) + getProgress(activeKey);//e.g. 2.75
        }
        return -1;
    };
    const getSection = (i, downhill) => {
        if (i === 0) {
            return <Welcome store={store} state={getState(`${i}`)} color={colors[i]} index={i}
                            progress={getProgress(`${i}`)}/>
        }
        if (i === 1) {
            return <CampusPlanning store={store} state={getState(`${i}`)} color={colors[i]} index={i}
                                   downhill={downhill}/>
        }
        if (i === 2) {
            return <CampusDesign store={store} state={getState(`${i}`)} color={colors[i]} index={i}
                                 downhill={downhill}/>
        }
        if (i === 3) {
            return <LifeOnCampus store={store} state={getState(`${i}`)} color={colors[i]} index={i}
                                 downhill={downhill}/>
        }
        if (i === 4) {
            return <Academics store={store} state={getState(`${i}`)} color={colors[i]} index={i} downhill={downhill}/>
        }
        if (i === 5) {
            return <GettingAround store={store} state={getState(`${i}`)} color={colors[i]} index={i}
                                  downhill={downhill}/>
        }
        if (i === 6) {
            return <EnergyWaterClimate store={store} state={getState(`${i}`)} color={colors[i]} index={i}
                                       downhill={downhill}/>
        }
        if (i === 7) {
            return <CampusPriorities store={store} state={getState(`${i}`)} color={colors[i]} index={i}
                                     downhill={downhill} progress={getProgress(`${i}`)}/>
        }
        if (i === 8) {
            return <Conclusion store={store} state={getState(`${i}`)} color={colors[i]} index={i} downhill={downhill}/>
        }
        return null;
    };
    const fullWidth = document.documentElement.clientWidth;

    const mainSection = (i) => {
        let downhill = i % 2 === 0;
        return (<ScrollSection background={colors[i]} store={store} key={i}
                               sectionGroup={'main'} sectionKey={`${i}`}>
            {i > 0 && <Aperture width={fullWidth} height={fullWidth / 20} color={colors[i - 1]} downhill={downhill}/>}
            {getSection(i, downhill)}
        </ScrollSection>);
    };

    if (!store.persistStore.profileSet) {
        return mainSection(0);
    }

    // if (store.sections.get('0')) {
    //     console.log('OPEN AMOUNTS '+store.sections.get('0').scrollProgress);
    //     console.log(0.1, );
    //
    // }

    const navNorms = {min: 0.5, max: 0.65};

    if (store.interactionsStore.mobileMode) {
        if (store.sections.get('0')) {
            navNorms.min = 0.65;
            navNorms.max = 0.85;
            // console.log('SP : ' + store.sections.get('0').scrollProgress);
        }
    }

    return (
        <Fragment>
            <div className={'ScrollContent'}>
                {testSections.map(({v}, i) => mainSection(i))}
                <ScrollSection store={store} background={'#dcd5c6'} sectionGroup={'main'} sectionKey={"about-you"}>
                    <AboutYou store={store} index={testSections.length}/>
                </ScrollSection>
                <ScrollSection store={store} background={'#dcd5c6'} sectionGroup={'main'} sectionKey={"bear"}
                               height={400}>
                    <Parallax store={store} progress={getProgress('bear')}/>
                    <Bear selectedIndices={store.selectedIndices}
                          store={store}
                          scrollAmount={getScrollAmount('main')}
                          openAmount={getProgressNorm('0', true, navNorms.min, navNorms.max)}
                          progress={getProgress('bear')}/>
                </ScrollSection>
                <ScrollSection store={store} background={'#2d343b'} sectionGroup={'main'} sectionKey={"bottom"}
                               height={1100}>
                    <div className={'bottom-thanks'}>
                        <div className={'thanks'}>Thanks for joining us!</div>
                        <div className={'more'}>
                            <p>
                                Where are we going next? This isn’t your only opportunity to get involved with the
                                planning process.
                            </p>
                            <p>
                                Head over to the <a target={'_blank'} href={'https://lrdp.berkeley.edu/'}>Long Range
                                Development Plan</a> and <a target={'_blank'}
                                                            href={'https://masterplan.berkeley.edu/home'}>Campus Master
                                Plan</a> websites to see the project timelines.
                            </p>
                            <ul>
                              <li><a href="mailto:lrdp@berkeley.edu">lrdp@berkeley.edu</a></li>
                              <li><a href="mailto:masterplan@berkeley.edu">masterplan@berkeley.edu</a></li>
                            </ul>
                        </div>
                    </div>
                </ScrollSection>
            </div>
        </Fragment>
    );
}

export default observer(ScrollContent);
